import type { HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  bottomPaddingClassName?: string;
}

const DEFAULT_BOTTOM_PADDING_CLASS = 'safe-area-bottom';

export const BottomButtonWrapper = ({
  children,
  className,
  style,
  bottomPaddingClassName = DEFAULT_BOTTOM_PADDING_CLASS,
  ...rest
}: Props) => (
  <div
    {...rest}
    className={twMerge(
      'sticky bottom-0 left-0 right-0 max-w-[600px] mx-auto px-4 bg-white pointer-events-none [&_*]:pointer-events-auto w-full',
      bottomPaddingClassName,
      className,
    )}
    style={{
      borderTop: '1px solid rgba(138, 138, 138, 0.1)',
      ...style,
    }}
  >
    {children}
  </div>
);
